import * as types from "../actions/CMSData";
const initialState = {
  cmsdatadetail: [],
  loading: false,
  error: null,
};

const cmsDatadetailsReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_CMSDATA_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case types.FETCH_CMSDATA_SUCCESS:
      return {
        ...state,
        loading: false,
        cmsdatadetail: action.payload,
        error: null,
      };
    case types.FETCH_CMSDATA_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default cmsDatadetailsReducer;
